import { GoiGroupDto } from '@/generated/model';
import { SetStateAction } from 'react';
import { ReactElement } from 'react';
import { Dispatch } from 'react';
import { createContext } from 'react';
import { useUserPreferencesState } from '@/hooks/useUserPreferencesState';

const SELECTED_GOI_GRPUPS_PREFERENCES_KEY = 'selectedGoiGroups';

type MapContextType = {
  selectedGoiGroup: GoiGroupDto[];
  setSelectedGoiGroup: Dispatch<SetStateAction<GoiGroupDto[]>>;
};

export const ctxMap = createContext<MapContextType | undefined>(undefined);

export function MapContext({ children }: { children: ReactElement }) {
  const [selectedGoiGroup, setSelectedGoiGroup] = useUserPreferencesState<GoiGroupDto[]>(
    SELECTED_GOI_GRPUPS_PREFERENCES_KEY,
    []
  );

  return (
    <ctxMap.Provider
      value={{
        selectedGoiGroup,
        setSelectedGoiGroup,
      }}
    >
      {children}
    </ctxMap.Provider>
  );
}
